export default __webpack_public_path__ + "static/media/gallery-wip-neck-grenade_04.20094019.jpg";